import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import MobileCardView from './MobileCardView';
import DataGridWrapper from './DataGridWrapper';

const MemoizedDataGridWrapper = React.memo(DataGridWrapper);

const ResponsiveGrid = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return isMobile ? <MobileCardView /> : <MemoizedDataGridWrapper />;
};

export default ResponsiveGrid;